import React from 'react';
import { connect } from 'react-redux';
import { Typography, Button } from '@mui/material';
import { Page, Row, Fill } from '../util/Page';

const AlertStats = ({ alerts, setCreatingAlert }) => {
  const numOkay = alerts.filter((a) => a.state === 'OKAY').length;
  return (
    <Page name="alert-stats">
      <Row>
        <Typography variant="h6">Data Alerts</Typography>
        <Fill />
        <Typography variant="p" style={{ lineHeight: '34px' }}>
          {alerts.length} alerts ({numOkay} okay)
        </Typography>
        <Fill />
        <Button onClick={() => setCreatingAlert(true)}>Create New Alert</Button>
      </Row>
    </Page>
  );
};

export default connect(
  ({
    entities: {
      dataAlerts: { alerts, actionsByAlert },
    },
  }) => ({ alerts, actionsByAlert })
)(AlertStats);
